import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppConfiguration } from '../../AppConfiguration';
import config from '../../config/config';
import { Translate, useTranslation } from '../../config/TranslationProvider';
import { eventDate, eventDuration, extractTime, findCategory, findLowestPrice, useWindowWidth } from '../../helper';
import CopyrightedImage from '../partials/CopyrightedImage';
import Badge from './Badge';
import EventProblemBadge from './EventProblemBadge';
import EventDateDayRow from './EventDateDayRow';

const EventsCard = ({
    isGrid = true,
    event: {medialist, id, is_highlight, is_online_event, location, prices, title, event_dates, categories},
    allCategories
}) => {
    const {breakpoints} = config;

    // Don't show the cheapest price if the price filter is disabled (Erlebnisregion requirement)
    const { filterConfiguration } = useAppConfiguration();
    const priceEnabled = typeof filterConfiguration.price === 'undefined' || filterConfiguration.price !== false;

    const newDate = useTranslation('newDate');

    const image = medialist[0];
    const start = event_dates[0].start_date;
    const end = event_dates[0].end_date;
    const eventIsCancelled = event_dates[0].is_cancelled;
    const eventIsRescheduled = event_dates[0].is_rescheduled;
    const rescheduledStartDate = event_dates[0].rescheduled_start_date;
    const rescheduledEndDate = event_dates[0].rescheduled_end_date;
    const fullDay = extractTime(start) === extractTime(end);

    // Show price in list view on small screens
    const [size] = useWindowWidth();
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        setIsMobile(!(size >= breakpoints.sm));
    }, [size, setIsMobile, breakpoints]);

    const eventStartAndEndTime = fullDay
        ? <Translate value="full_day" />
        : eventDuration(start, end)
    ;
    const eventRescheduledStartAndEndTime = fullDay
        ? <Translate value="full_day" />
        : eventDuration(rescheduledStartDate, rescheduledEndDate)
    ;

    return (
        <Link to={'/events/' + id} aria-label="event">
            <article className="atbd_single_listing_wrapper">

                <figure className="atbd_listing_thumbnail_area">
                    <div className="atbd_listing_image">
                        {image && <CopyrightedImage image={image} size="medium" alt="event_image" />}
                    </div>
                    <div className="atbd_thumbnail_overlay_content">
                        <ul className="atbd_upper_badge">
                            {isGrid && categories[0] && allCategories[0] &&
                                <Badge type="category" description={findCategory(allCategories, categories[0]).title} />
                            }
                            {!isGrid && !is_highlight && categories[0] && allCategories[0] &&
                                <Badge type="category" description={findCategory(allCategories, categories[0]).title} />
                            }
                            {is_highlight && <Badge type="highlight" description="Highlight" />}
                            {is_online_event && <Badge type="online" description="Online" />}
                        </ul>
                    </div>

                </figure>

                <div className="atbd_listing_info">
                    <div className="atbd_content_upper">
                        {eventIsCancelled && <EventProblemBadge classes="mb-4" type="cancelled" />}
                        {eventIsRescheduled && <EventProblemBadge classes="mb-4" type="rescheduled" />}

                        <h4 className="atbd_listing_title">{title}</h4>

                        {(isGrid || isMobile) && priceEnabled && <div className="atbd_listing_meta">
                            <span className="atbd_meta atbd_listing_price">
                                {findLowestPrice(prices)}
                            </span>
                        </div>}

                        <div className="atbd_listing_data_list">
                            <ul>
                                {is_online_event && (
                                    <li>
                                        <p><span className="la la-globe" /><Translate value="online_event" /></p>
                                    </li>
                                )}
                                {!is_online_event && location.title && (
                                    <li>
                                        <p><span className="la la-building" />{location.title}</p>
                                    </li>
                                )}
                                {!is_online_event && (location.address || location.city) && (
                                    <li>
                                        <p>
                                            <span className="la la-map-marker" />
                                            {[location.address, location.city].filter(val => val).join(', ')}
                                        </p>
                                    </li>
                                )}
                                <li>
                                    <EventDateDayRow start={start} end={end} hasMoreDates={event_dates.length > 1}>
                                        {!isGrid && <>
                                            {eventStartAndEndTime}
                                        </>}
                                    </EventDateDayRow>
                                </li>
                                {eventIsRescheduled && (
                                    <li>
                                        <p className="rescheduled-color"><span className="la la-calendar rescheduled-color" />
                                            {rescheduledStartDate
                                                ? `${newDate} ${eventDate(rescheduledStartDate, rescheduledEndDate)}`
                                                : <Translate value="newDateUnknown" />
                                            }
                                            {!isGrid && <>
                                                {', '}{eventRescheduledStartAndEndTime}
                                            </>}
                                        </p>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    {isGrid && (
                        <div className="atbd_listing_bottom_content">
                            <div className="atbd_content_left">
                                <div className="atbd_listing_category block">
                                    <span className="la la-clock-o" />
                                    {' '}{eventStartAndEndTime}

                                    {eventIsRescheduled && rescheduledStartDate && (
                                        <p className="rescheduled-color mb-0">
                                            <span className="la la-clock-o rescheduled-color" />
                                            {' '}{eventRescheduledStartAndEndTime}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </article>
        </Link>
    );
};

export default EventsCard;
